import React, { useEffect } from 'react'
import Navbar from '../../GlobalComponents/Navbar/Navbar'
import MobileNavbar from '../../../Mobile/MobGlobalComponents/MobileNavbar/MobileNavbar'
import { useLocation, useNavigate } from 'react-router-dom'
import { fetchCartDetails } from '../../../../utils/cartSlice'
import { useDispatch } from 'react-redux'

export const PaymentFailurePage = ({ user }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const location = useLocation() // Hook to get the current location

	useEffect(() => {
		// Scroll to the top whenever the location changes
		window.scrollTo(0, 0)
	}, [location]) // Dependency on location

	useEffect(() => {
		const timer = setTimeout(() => {
			navigate('/')
		}, 3000) // 3000ms = 3 seconds

		return () => clearTimeout(timer) // Clean up the timer on component unmount
	}, [navigate])

	useEffect(() => {
		dispatch(fetchCartDetails())
		// Initialize the cart from localStorage when the app loads
	}, [])

	return (
		<>
			<div className='display'>
				<Navbar user={user} />
				<PaymentFailurePageMain />
			</div>
			<div className='display-full'>
				<MobileNavbar user={user} />
				<PaymentFailurePageMain />
			</div>
		</>
	)
}

const PaymentFailurePageMain = () => {
	return (
		<div className='min-h-screen flex items-center justify-center mt-10'>
			<div className='text-center'>
				<svg id='Layer_3' height='100' viewBox='0 0 24 24' width='100' xmlns='http://www.w3.org/2000/svg' data-name='Layer 3'>
					<g fill='#f44336'>
						<rect height='3' rx='.5' width='3' x='5.5' y='10.5' />
						<path d='m12 1a11 11 0 1 0 11 11 11 11 0 0 0 -11-11zm6.3535 15.6465a.5.5 0 1 1 -.707.707l-1.1465-1.1465-1.1465 1.1465a.5.5 0 0 1 -.707-.707l1.1465-1.1465-1.1465-1.1465a.5.5 0 0 1 .707-.707l1.1465 1.1465 1.1465-1.1465a.5.5 0 0 1 .707.707l-1.1465 1.1465zm1.1465-4.6465a.5.5 0 0 1 -1 0v-3.5a1.5017 1.5017 0 0 0 -1.5-1.5h-9a1.5017 1.5017 0 0 0 -1.5 1.5v1h1.5a1.5017 1.5017 0 0 1 1.5 1.5v2a1.5017 1.5017 0 0 1 -1.5 1.5h-1.5v1a1.5017 1.5017 0 0 0 1.5 1.5h4a.5.5 0 0 1 0 1h-4a2.5026 2.5026 0 0 1 -2.5-2.5v-1.0921a1.4977 1.4977 0 0 1 -1-1.4079v-2a1.4977 1.4977 0 0 1 1-1.4079v-1.0921a2.5026 2.5026 0 0 1 2.5-2.5h9a2.5026 2.5026 0 0 1 2.5 2.5z' />
					</g>
				</svg>

				<h1 className='text-3xl font-bold text-gray-800 mb-2 mt-2'>Order Failed</h1>
				<p className='text-gray-600'>We're sorry, but there was an issue processing your order. Please try again.</p>
			</div>
		</div>
	)
}

export default PaymentFailurePage
